import 'react-on-rails-pro/registerDefaultRSCProvider/client';
import ReactOnRails from 'react-on-rails-pro/client';
import ProductSearchSSR from '../../startup/ProductSearchSSR.tsx';

ReactOnRails.register({ProductSearchSSR});